import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'flowbite/dist/flowbite.js';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { initReactI18next } from 'react-i18next';
import { Provider } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import Loader from './components/Loader/Loader';
import './index.css';
import store from './store';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    supportedLngs: ['en', 'ar'],
    fallbackLng: 'en',
    detection: {
      order: ['path', 'cookie', 'htmlTag', 'localStorage', 'subdomain'],
      caches: ['cookie']
    },
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json' //we can the resouce file from api also, in our case we are using relative path
    }
  });

const loadingMarkup = (
  <div className="h-screen">
    <div className="flex justify-center items-center h-full">
      <Loader/>
    </div>
  </div>
);
// if ('serviceWorker' in navigator) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('/sw.js') 
//       .then((registration) => {
//         console.log('Service Worker registered with scope:', registration.scope);
//       })
//       .catch((error) => {
//         console.error('Service Worker registration failed:', error);
//       });
//   });
// }
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
  <Suspense fallback={ loadingMarkup  }>
      <Provider store={store}>
        <App />
        {/* <TranslationComponent> */}
      </Provider>
  </Suspense>
    // </React.StrictMode>
);
